var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userAccount)?_c('div',{staticClass:"sm-account-cont"},[_c('account-upper'),_c('account-main')],1):_c('sm-spinner',{attrs:{"show":!_vm.userAccount}})}
var staticRenderFns = []

export { render, staticRenderFns }